// extracted by mini-css-extract-plugin
export var darkActive = "header-module--darkActive--2f325";
export var darkIcon = "header-module--darkIcon--d1456";
export var logoIcon = "header-module--logoIcon--f41b1";
export var menu_togglebtn = "header-module--menu_togglebtn--9d788";
export var searchbtnwrap = "header-module--searchbtnwrap--22665";
export var searchtxt = "header-module--searchtxt--013f7";